/**
 * Auth key local storage key
 */
export const AUTH_KEY = 'auth-key';

/**
 * Account status local storage key
 */
export const STATUS = 'status';

/**
 * Authorization code that means 2fa is required
 */
export const TWO_FA_REQUIRED_STATUS_CODE = 1036;

/**
 * Sign up code that means need to verify phone
 */
export const NEED_VERIFY_PHONE_STATUS_CODE = 1;

/**
 * Authorization error code from backend
 */
export const AUTHORIZATION_ERROR_CODE = '101';

/**
 * Expired token error code from backend
 */
export const EXPIRED_TOKEN_ERROR_CODE = '106';
